export default __webpack_public_path__ + "static/9-6b7917ce8590fe3847c0972d412535ed.png";